export default __webpack_public_path__ + "static/media/L_wdt_c_cap_3.5f853a2c.mp3";